<button
  class="app-access-button"
  tiime-button
  [large]="large"
  color="primary"
  icon
  tiimeTooltip="Tiime Apps"
  (click)="$event.preventDefault(); $event.stopPropagation(); openApps()"
>
  <svg class="app-access-button-icon">
    <use [attr.xlink:href]="icon"></use>
  </svg>
</button>
